export default __webpack_public_path__ + "cf49212d119955e9d5416d780adf8a90.png";